// extracted by mini-css-extract-plugin
module.exports = {"input":"Accordion_input__hBYqd"};